function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.334 23.267c0-12.126 9.837-21.934 22-21.934 12.162 0 22 9.808 22 21.934 0 16.45-22 40.733-22 40.733s-22-24.283-22-40.733z",
  fill: "#eb1700"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.666",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.666",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.113 18.286a2.743 2.743 0 00-2.737 2.737 2.74 2.74 0 001.987 2.633v3.615a4.318 4.318 0 01-4.312 4.312 4.32 4.32 0 01-4.283-3.795c1.245-.307 3.51-1.38 4.058-5.16v.008l.007-.015 1.2-6.413c.053-.292.233-2.092-1.995-2.34-1.282-.142-2.617-.285-2.617-.285l.007 1.913 2.633-.27c.202 0 .382.075.502.217.12.143.173.33.143.518l-1.208 6.39c-.412 1.627-1.875 2.49-3.555 2.49-1.68 0-3.142-.863-3.555-2.49l-1.207-6.39a.594.594 0 01.142-.518c.12-.142.3-.217.503-.217l2.632.27v-1.913s-1.335.143-2.617.285c-2.228.248-2.048 2.048-1.995 2.34l1.207 6.413.008.015v-.008c.57 3.938 3.007 4.943 4.207 5.19a5.816 5.816 0 005.783 5.258 5.822 5.822 0 005.812-5.813v-3.615a2.74 2.74 0 001.988-2.632c0-1.5-1.23-2.73-2.738-2.73zm0 3.975a1.239 1.239 0 010-2.475 1.239 1.239 0 010 2.475z",
  fill: "#eb1700"
}), /*#__PURE__*/React.createElement("defs", {
  id: "defs3"
}, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath3"
}, /*#__PURE__*/React.createElement("rect", {
  x: "14.666",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff",
  id: "rect4"
})))));